import HorizontalImageCard from "../elements/horizontalImageCard";


export default function CarouselCard8() {

    return (
        <div className="flex">

            <div className="">
                <div className="grid grid-cols-1 md:grid-cols-2 md:w-full mx-12">
                    <div className="swiper-slide card-slide card-slide-left  ">

                        <HorizontalImageCard
                            imageURL="https://media.licdn.com/dms/image/v2/D4D22AQHpx0o3_gpzTA/feedshare-shrink_800/B4DZYpHKFAHwAg-/0/1744446464731?e=2147483647&v=beta&t=Y7kzksMYWbQmpgAkaMyxoiMNd9z7olQNydFkLxqJPfE"
                            imageAlt="inquiry based learning"
                            title="You’re Making High-Stakes Decisions Daily"
                            blurb="At Extern
                                Academy, you
                                aren’t handed
                                answers — you
                                own the outcome.
                                Every sprint,
                                every pivot, and
                                every product
                                decision is yours
                                to make. That
                                pressure is
                                intentional: it’s
                                the fastest way
                                to build real
                                judgment."
                        />
                    </div>
                    <div className="swiper-slide card-slide card-slide-center  ">
                        <HorizontalImageCard
                            imageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/editorial/greptile-web-article-1200-x-630-px-.webp"
                            imageAlt="Extern Academy Teamwork"
                            title="Startup Atelier"
                            blurb="
                                The founder performance workshop, combining coaching, diagnostics, and health science to help externs scale without breaking.


                                Each of our
                                campuses offers
                                an atelier that
                                caters
                                specifically to
                                our high school
                                learners,
                                allowing them to
                                foster natural
                                curiosity and
                                learn through
                                hands-on
                                experiences."
                        />
                    </div>


                </div>

            </div>
        </div>
    )
}